import { mergeRight, uniq } from 'ramda';
import { path } from 'Utility/ramdaReplacement';
import { sortStrengths } from 'Utility/randomUtil';

export const strengthsArray = (packages: IMedicationPackage[]): { [key: string]: string }[] => {
  const strengths = packages.map((p: IMedicationPackage) => p.strengths);
  return uniq(strengths).sort((a1, a2) => sortStrengths(a1, a2));
};

export const valueFilter = (
  availableStrengths: Array<IStrengths>,
  strengths: Array<IStrengths>,
  comparison: (n1: number, n2: number) => boolean,
): number | string => {
  const numberOfStrengths = path(
    [0],
    availableStrengths.map((s, i) => (strengths.includes(s) ? i : null)).filter(j => j !== null),
  ) as number;
  return comparison(numberOfStrengths, 0) ? numberOfStrengths : '';
};

export const strengthsOnChange =
  (
    onChange: IFormData['onChange'],
    strArr: Array<IStrengths>,
    index: number,
    thisRegimen?: Regimen,
    allRegimen?: TArrayWithID<Regimen> | null | undefined,
  ) =>
  (values: TOnChangeValues): void => {
    if (thisRegimen && allRegimen) {
      const name = Object.keys(values)[0];
      if (!name) return;
      const value = [strArr[values[name] as number]];

      const thisRegimens = { ...thisRegimen };
      const allRegimens = [...allRegimen];

      allRegimens[index] = mergeRight(thisRegimens, { [name]: value as any, vnr: '' });
      onChange?.({ regimen: allRegimens });
    }
  };

export const otherOnChange =
  (
    onChange: IFormData['onChange'],
    index: number,
    thisRegimen: Regimen | null | undefined,
    allRegimen?: TArrayWithID<Regimen> | null | undefined,
  ) =>
  (values: TOnChangeValues): void => {
    const name = Object.keys(values)[0];
    if (!name) return;
    const value = values[name];
    if (thisRegimen && allRegimen) {
      const thisRegimens = { ...thisRegimen };
      const allRegimens = [...allRegimen];

      allRegimens[index] = mergeRight(thisRegimens, { [name]: value } as any);
      // Update all regimen
      onChange?.({ regimen: allRegimens });
    }
  };
